import { IComboBoxOption } from "@fluentui/react/lib";
import { List } from "linq.ts";
import { IObject } from "../portal/types";
import { IExtendedEntitySchema } from "../data";
import { DataType } from "./DataType";

export enum EntityType {
    entity = 1,
    documentRepository = 2
}

export const EntityTypeDataSource: IComboBoxOption[] = new List<IComboBoxOption>([
    { key: EntityType.entity, text: 'Entidad' },
    { key: EntityType.documentRepository, text: 'Repositorio de documentos' },
]).OrderBy(x => x.text).ToArray();

export const NativeEntitySchemas: IObject<IExtendedEntitySchema>[] = [
    {
        objectId: '00000000-0000-0000-0000-000000000001',
        name: 'ArchivoX - Sección',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000001',
                    name: 'Codigo',
                    code: 'Code',
                    dataType: DataType.uniqueIdentifier,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000030',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000027',
                    name: 'IdSeccion',
                    code: 'IdSeccion',
                    dataType: DataType.int,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000002',
        name: 'ArchivoX - Serie',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000003',
        name: 'ArchivoX - Subserie',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000004',
        name: 'ArchivoX - Usuario',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000005',
        name: 'ArchivoX - Rol',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000006',
        name: 'ArchivoX - Perfil',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000007',
        name: 'ArchivoX - País',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000008',
        name: 'ArchivoX - Departamento',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000009',
        name: 'ArchivoX - Ciudad',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000010',
        name: 'TramiteX - Contacto',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000011',
        name: 'TramiteX - Día festivofestivo',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000012',
        name: 'TramiteX - Género',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000013',
        name: 'TramiteX - Grupo étnico',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000014',
        name: 'ArchivoX - Tipo documental',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000015',
        name: 'ArchivoX - Documento',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000016',
        name: 'ArchivoX - Expediente',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000020',
        name: 'TramiteX - Tipo de identificación',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
    {
        objectId: '00000000-0000-0000-0000-000000000021',
        name: 'ProcesoX - Documento aplicación',
        code: '',
        enabled: true,
        schema: {
            attributes: [
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    dataType: DataType.int,
                    enabled: true
                },
                {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'Nombre',
                    code: 'Nombre',
                    dataType: DataType.string,
                    enabled: true
                }
            ],
            type: EntityType.entity
        }
    },
]